import { sva } from '@repo/pandacss/css';

export const badge = sva({
  slots: ['container', 'icon', 'text'],
  base: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '2',
      px: '3',
      py: '2',
      borderRadius: 'sm',
    },
    icon: {
      alignItems: 'center',
      verticalAlign: 'middle',
    },
    text: {
      fontSize: 'inherit',
      textAlign: 'center',
      flexWrap: 'wrap',
      verticalAlign: 'middle',
    },
  },
  variants: {
    colorVariant: {
      green1: {
        container: {
          bgColor: 'greens.lightest',
          color: 'primary.dark',
        },
        icon: {
          color: 'primary.dark',
        },
      },
      green2: {
        container: {
          bgColor: 'greens.lighter',
          color: 'greens.darkest',
        },
        icon: {
          color: 'primary.dark',
        },
      },
      blue: {
        container: {
          bgColor: 'blues.extraLight',
          color: 'blues.dark',
        },
        icon: {
          color: 'blues.dark',
        },
      },
    },
  },
  defaultVariants: {
    colorVariant: 'green1',
  },
});
